<table class="subwindow" [cdkDragConstrainPosition]="constrainPosition" plessTitleWindowSub cdkDrag [windowMovable]="false" [windowResizable]="false"
  [frontDispFlag]="true">
  <tr class="subwindow-title" cdkDragHandle>
    <th class="window-title-name">業態別企画書データ出力</th>
    <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
  </tr>
  <tr class="subwindow-body">
    <td>
      <div class="contents-area" (dragstart)="onDragstartBody($event)">

        <div class="column-list">
          <label class="list-input-title">受注コード</label>
          <div class="list-input-content">
            <app-order-code-text-input id="txti_OrderCodeFrom" #txti_OrderCodeFrom [subid]="'txti_OrderCodeFrom'"
              [(ngModel)]="kymw1311Model.orderCodeFrom" [required]="true" [catalogIDField]="lbl_DelivCatalogIDFrom"
              [forcedEnabledMode]="'true'" [autofocus]="true" [tabindex]="0"></app-order-code-text-input>
            <label>～</label>
            <app-order-code-text-input id="txti_OrderCodeTo" #txti_OrderCodeTo [subid]="'txti_OrderCodeTo'"
              [(ngModel)]="kymw1311Model.orderCodeTo" [required]="true" [catalogIDField]="lbl_DelivCatalogIDTo"
              [forcedEnabledMode]="'true'" [tabindex]="0"></app-order-code-text-input>
          </div>

          <label class="list-input-title">配達企画回（翌週）</label>
          <div class="list-input-content">
            <input type="text" class="deliv-catalog" id="lbl_DelivCatalogIDFrom" #lbl_DelivCatalogIDFrom readonly/>
            <label>～</label>
            <input type="text" class="deliv-catalog" id="lbl_DelivCatalogIDTo" #lbl_DelivCatalogIDTo readonly/>
          </div>

          <label class="list-input-title">媒体</label>
          <div class="list-input-content">
            <app-plan-medium-type-combo-box id="cmb_MediumType" #cmb_Medium [subid]="'cmb_Medium'"
              [(ngModel)]="kymw1311Model.mediumType" [required]="false" [forcedEnabledMode]="'true'"
              [tabindex]="0" style="width: 100%;">
            </app-plan-medium-type-combo-box>
          </div>

          <label class="list-input-title">部門</label>
          <div class="list-input-content" style="height: 108px;">
            <app-classifications-list id="lst_Classifications" #lst_Classifications [subid]="'lst_Classifications'"
              [forcedEnabledMode]="'true'" [tabindex]="0"></app-classifications-list>
          </div>

          <label class="list-input-title">Ｐコード</label>
          <div class="list-input-content">
            <input type="text" class="text-label-normal pcode" id="txti_PCode" [(ngModel)]="kymw1311Model.pCode"
              plessInputTextSub [restrict]="'[P0-9]'" [maxlength]="8" forcedEnabledMode="true" [tabindex]="0" />
          </div>

          <label class="list-input-title">業態区分(ウィークリー)</label>
          <div class="list-input-content">
            <app-checkbox-label label="掲載あり" id="ckb_duties_weekly" #ckb_duties_weekly [subid]="'ckb_duties_weekly'"
              [(ngModel)]="kymw1311Model.dutiesWeeklyFlag" [forcedEnabledMode]="'true'"
              [tabindex]="0"></app-checkbox-label>
          </div>

          <label class="list-input-title">業態区分(デイリー)</label>
          <div class="list-input-content">
            <app-code-list [height]="'155px'" id="lst_duties_daily" #lst_duties_daily [subid]="'lst_duties_daily'"
              [codeDiv]="'ctp123'" [forcedEnabledMode]="'true'" [tabindex]="0"></app-code-list>
          </div>

          <label class="list-input-title">業態区分(スポット)</label>
          <div class="list-input-content">
            <app-checkbox-label label="掲載あり" id="ckb_duties_spot" #ckb_duties_spot [subid]="'ckb_duties_spot'"
              [(ngModel)]="kymw1311Model.dutiesSpotFlag" [forcedEnabledMode]="'true'"
              [tabindex]="0"></app-checkbox-label>
          </div>
        </div>
      </div>
    </td>
  </tr>

  <tfoot cdkDragHandle>
    <tr>
      <td>
        <div class="footer-buttons">
          <button id="btn_Out" class='btn-primary' (click)="eventOut_CLICKHandler()" forcedEnabledMode="true"
            [tabindex]="0">出力</button>
        </div>
        <div class="window-title-close">
          <!-- ダイアログ閉じるボタンを最後にフォーカスしたいため最後方に移動済 -->
          <button [tabindex]="0" (click)="onClickWindowClose()"></button>
        </div>
      </td>
    </tr>
  </tfoot>
</table>